import { createContext, use } from 'react';

/**
 * What the composer opens with already selected. A client alone opens the
 * matter picker listing only that client's matters.
 */
export interface ActivityComposerOptions {
  clientId: string;
  clientProjectId?: string;
}

export interface ActivityComposerContextValue {
  openComposer: (options?: ActivityComposerOptions) => void;
}

export const ActivityComposerContext = createContext<ActivityComposerContextValue | null>(null);

export function useActivityComposer(): ActivityComposerContextValue {
  const ctx = use(ActivityComposerContext);
  if (!ctx) {
    throw new Error('useActivityComposer must be used inside ActivityComposerProvider');
  }
  return ctx;
}
